module.exports = __webpack_public_path__ + "img/no-data-dashboard.ba3e6791.svg";